import { ComponentProps } from "../registry";
import { useBound } from "../helpers";
import { BoundValue } from "../../types";

/**
 * v1: lightweight icon by name. Maps a small set of common names to unicode
 * glyphs. Future: replace with a proper icon set (Lucide, Heroicons, custom SVGs).
 */
const GLYPHS: Record<string, string> = {
  user: "👤", users: "👥", check: "✓", x: "✕", close: "✕",
  warning: "⚠", error: "⚠", info: "ⓘ", search: "🔍",
  calendar: "📅", clock: "🕐", folder: "📁", file: "📄",
  upload: "⬆", download: "⬇", plus: "+", minus: "−",
  star: "★", heart: "♥", lock: "🔒", mail: "✉",
  arrowRight: "→", arrowLeft: "←", arrowUp: "↑", arrowDown: "↓",
};

export function Icon({ fields, scope }: ComponentProps) {
  const name = useBound<string>(fields.name as BoundValue, scope) ?? "";
  const glyph = GLYPHS[name] ?? "•";
  return <span className="a2-icon" aria-label={name}>{glyph}</span>;
}
